import Component from "@glimmer/component";
import { service } from "@ember/service";
import DHeadlessMenu from "float-kit/components/d-headless-menu";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
export default class DMenus extends Component {
  static {
    dt7948.g(this.prototype, "menu", [service]);
  }
  #menu = (dt7948.i(this, "menu"), void 0);
  static {
    setComponentTemplate(precompileTemplate("\n    <div id=\"d-menu-portals\"></div>\n\n    {{#each this.menu.registeredMenus key=\"id\" as |menu|}}\n      {{#if menu.detachedTrigger}}\n        <DHeadlessMenu @menu={{menu}} />\n      {{/if}}\n    {{/each}}\n  ", {
      strictMode: true,
      scope: () => ({
        DHeadlessMenu
      })
    }), this);
  }
}